<template lang="pug">
  .v-input(:class="classes")
    template(v-if="!isDatePicker")
      input.v-input__field(
        v-focus="focus"
        type="text"
        required
        :value="value"
        :disabled="disabled"
        :autocomplete="autocomplete"
        @input="onInput")
    template(v-else)
      slot(
        name="date-picker"
        v-bind="{ isDatePicker }")
    label.v-input__label(:class="focusLabel") {{ label }}
    .v-input__bar(:class="focusBar")
    .v-input__hint(v-if="hint") {{ hint }}
    .v-input__icon.v-input__icon--right(
      :class="focusIcon")
      slot(name="icon-right")
</template>

<script>
export default {
  name: 'VInput',

  props: {
    label: String,
    value: [String, Number],
    disabled: Boolean,
    autocomplete: {
      type: String,
      default: 'off'
    },
    isDatePicker: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    },
    isVisiblePopover: Boolean,
    focus: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes () {
      return {
        'v-input--invalid': this.invalid
      }
    },
    focusLabel () {
      return {
        'v-input__label--focus': (this.isDatePicker && !!this.value) || this.isVisiblePopover
      }
    },

    focusBar () {
      return {
        'v-input__bar--focus': this.isDatePicker && this.isVisiblePopover
      }
    },

    focusIcon () {
      return {
        'v-input__icon--focus': this.isVisiblePopover
      }
    }
  },

  methods: {
    onInput (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_variables.scss';

  .v-input {
    position: relative;
    height: 4rem;

    &__hint {
    color: $color-red;
    font-size: 1.2rem;
    font-weight: 300;
    padding-top: .3rem;
    } 
    &--invalid {
    margin-bottom: 34px !important;
      label {
        color: $color-red !important;
      }
    }
    &--invalid &__field {
      color: $color-red !important;
      border-bottom: .3rem solid $color-red !important;
    }
    &__field {
      position: relative;
      width: 100%;
      font-size: 1.5rem;
      padding: 1rem 0;
      height: 4rem;
      display: block;
      border: none;
      background: transparent;
      border-bottom: .1rem solid $color-gray-light-2;
      z-index: 2;

      &--cursor-pointer {
        cursor: pointer;
        user-select: none;
      }

      &:focus {
        outline: none;
      }

      &:focus ~ .v-input__icon {
        color: $color-black;
      }

      &:focus ~ label,
      &:valid ~ label {
        top: -.8rem;
        font-size: 1.3rem;
        color: $color-gray;
      }

      &:disabled ~ label {
        color: $color-gray-light;
      }

      &:focus ~ .v-input__bar:before,
      &:focus ~ .v-input__bar:after {
        width: 50%;
      }
    }

    &__label {
      color: $color-black;
      font-size: 1.5rem;
      position: absolute;
      pointer-events: none;
      top: 1rem;
      transition: 0.2s ease all;

      &--focus {
        top: -.8rem;
        font-size: 1.3rem;
        color: $color-gray;
      }
    }

    &__bar {
      position: relative;

      &--focus {
        &::before,
        &::after {
          width: 50% !important;
        }
      }

      &:before,
      &:after {
        content: "";
        height: .2rem;
        width: 0;
        bottom: .1rem;
        position: absolute;
        background: $color-primary;
        transition: 0.2s ease all;
      }

      &:before {
        left: 50%;
      }

      &:after {
        right: 50%;
      }
    }

    &__icon {
      position: absolute;
      top: 0;
      height: 100%;
      width: 3rem;
      font-size: 2rem;
      color: $color-gray;
      display: flex;
      align-items: center;
      justify-content: center;

      &--focus {
        color: $color-black;
      }

      &--right {
        right: 0;
      }
    }
  }
</style>
